import styled from 'styled-components';

import { Text14 } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const EmptyFilterStateStyled = styled.div`
  width: 192px;
  height: 256px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: ${ct({ Dark: Colors.GreyDarker, Light: Colors.GreyDarker })};
  gap: 8px;
`;

export const EmptyStateTitleStyled = styled(Text14)`
  font-weight: 600;
`;
